import styles from "./About.module.css";

function About() {
  return (
    <div className={styles.about}>
      <div className={styles.copy}>
        <p className={styles.lead}>
          Software engineer with a First-Class BSc (Hons) in Computer Games
          Programming from Kingston University, building across product
          engineering, games, and AI-driven experiments.
        </p>
        <p>
          I have experience developing scalable web APIs, integrating cloud
          services, and working with financial and data-driven applications.
          My work spans polished frontend experiences, backend systems, and
          interactive tools that need both technical rigor and product taste.
        </p>
        <p>
          Previously, I worked as a Back-end Software Development Intern at
          Validus Reinsurance, where I built an ASP.NET Core Web API to support
          underwriters in data management and collaborated on Microsoft Power
          Apps development. I’ve also designed front-end applications,
          implemented automation workflows, and contributed to blockchain-based
          financial systems while working at Playmint.
        </p>
      </div>
      <div className={styles.highlights}>
        <div className={styles.highlight}>
          <div className={styles.highlightLabel}>Based in</div>
          <div className={styles.highlightValue}>United Kingdom</div>
        </div>
        <div className={styles.highlight}>
          <div className={styles.highlightLabel}>Current focus</div>
          <div className={styles.highlightValue}>Web platforms, games, and AI</div>
        </div>
        <div className={styles.highlight}>
          <div className={styles.highlightLabel}>Core strengths</div>
          <div className={styles.highlightValue}>
            Full stack delivery with product-minded execution
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
